import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LoginInitialState, LoggedUserType } from '../utils/Types';
import { LOGIN_STATUS, STORAGE_KEY } from '../utils/Constant';
import { candidateDetails, LoginV, logout, onPostSSOLogin } from '../services';
import {
  clearSession,
  getFromLocalStorage,
  removeFromLocalStorage,
  saveInLocalStorage,
} from '../utils/Util';
import { blankUserDetails } from './assignGridSlice';

export const blankUser: LoggedUserType = {
  candidateId: 0,
  candidateUniqueId: '',
  employeeUniqueId: '',
  firstname: '',
  lastName: '',
  userActivationStatus: 0,
  userActivationStatusName: '',
  accessToken: '',
  accessExpiryTime: '',
  resetToken: '',
  resetExpiryTime: '',
  mobileNumber: 0,
  emailId: '',
  loginType: 0,
  loginTypeName: '',
  roleId: -1,
};
export const initialState: LoginInitialState = {
  status: LOGIN_STATUS.NO_AUTHENTICATED,
  user: blankUser,
  userDetails: blankUserDetails,
  logout: null,
};

export const getLoggedUserDetails = createAsyncThunk(
  'login/fetchCandidate',
  async (candidateId: number) => {
    const res = await candidateDetails({ candidateId });
    return res.data;
  }
);
export const postSSOLogin = createAsyncThunk(
  'update/postLogin',
  async (data: any) => {
    const res = await onPostSSOLogin(data);
    return res.data;
  }
);
export const onLogout = createAsyncThunk('update/logout', async () => {
  const res = await logout();
  return res.data;
});
export const itusLogin = createAsyncThunk('itus/logiv', async (data: any) => {
  const res = await LoginV(data);
  return res.data;
});

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setAuthenticated: (state: LoginInitialState, action) => {
      state.status = action.payload.status;
      state.user = action.payload.user;
      saveInLocalStorage(
        STORAGE_KEY.AUTH_DATA,
        JSON.stringify(action.payload.user)
      );
    },
    setLocalLogout: (state: LoginInitialState) => {
      state.status = LOGIN_STATUS.NO_AUTHENTICATED;
      state.user = blankUser;
      removeFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      removeFromLocalStorage(STORAGE_KEY.ITUS);
      removeFromLocalStorage(STORAGE_KEY.POWERBI);
      clearSession();
    },
    checkAuthenticated: (state: LoginInitialState) => {
      const data = getFromLocalStorage(STORAGE_KEY.AUTH_DATA);
      if (data) {
        const sessionData: LoggedUserType = JSON.parse(data);
        if (sessionData?.accessToken) {
          state.status = LOGIN_STATUS.AUTHENTICATED;
          state.user = sessionData;
        }
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(itusLogin.fulfilled, (state: LoginInitialState, action) => {
        if (action?.payload?.token) {
          saveInLocalStorage(STORAGE_KEY.ITUS, action.payload.token);
        }
      })
      .addCase(getLoggedUserDetails.fulfilled, (state, action) => {
        if (action?.payload?.result) {
          state.userDetails = action.payload.result.user ?? blankUser;
        }
      })
      .addCase(onLogout.fulfilled, (state, action) => {
        state.logout = action.payload?.responseInformation;
      });
  },
});
export const loginSelector = (state: any) => state.login;
export const { setAuthenticated, setLocalLogout, checkAuthenticated } =
  loginSlice.actions;
export default loginSlice.reducer;
